import PropTypes from 'prop-types'
import React from 'react'
import icon_1 from './icons/uslugas/1'
import icon_2 from './icons/uslugas/2'
import icon_3 from './icons/uslugas/3'
import icon_4 from './icons/uslugas/4'
import icon_5 from './icons/uslugas/5'
import icon_6 from './icons/uslugas/6'
import icon_7 from './icons/uslugas/7'
import icon_8 from './icons/uslugas/8'
import icon_9 from './icons/uslugas/9'
import icon_10 from './icons/uslugas/10'
import icon_11 from './icons/uslugas/11'
import icon_12 from './icons/uslugas/12'
import icon_13 from './icons/uslugas/13'
import icon_14 from './icons/uslugas/14'
import icon_15 from './icons/uslugas/15'
import icon_16 from './icons/uslugas/16'
import icon_17 from './icons/uslugas/17'
import icon_18 from './icons/uslugas/18'
import icon_19 from './icons/uslugas/19'
import icon_20 from './icons/uslugas/20'
import icon_22 from './icons/uslugas/22'
import icon_23 from './icons/uslugas/23'
import icon_24 from './icons/uslugas/24'
import icon_26 from './icons/uslugas/26'
import icon_27 from './icons/uslugas/27'
import icon_28 from './icons/uslugas/28'
import icon_29 from './icons/uslugas/29'
import icon_30 from './icons/uslugas/30'
import icon_31 from './icons/uslugas/31'
import icon_32 from './icons/uslugas/32'
import icon_31_2 from './icons/uslugas/31_2'
import icon_33 from './icons/uslugas/33'
import icon_34 from './icons/uslugas/34'
import icon_35 from './icons/uslugas/35'
import icon_36 from './icons/uslugas/36'
import icon_37 from './icons/uslugas/37'
import icon_38 from './icons/uslugas/38'
import icon_39 from './icons/uslugas/39'
import icon_40 from './icons/uslugas/40'
import icon_41 from './icons/uslugas/41'
import icon_42 from './icons/uslugas/42'
import icon_43 from './icons/uslugas/43'
import icon_44 from './icons/uslugas/44'
import icon_49 from './icons/uslugas/49'
import icon_51 from './icons/uslugas/51'
import icon_52 from './icons/uslugas/52'
import icon_53 from './icons/uslugas/53'
import icon_54 from './icons/uslugas/54'
import icon_55 from './icons/uslugas/55'
import icon_56 from './icons/uslugas/56'
import icon_62 from './icons/uslugas/62'
import icon_64 from './icons/uslugas/64'
import icon_66 from './icons/uslugas/66'
import icon_67 from './icons/uslugas/67'
import icon_all from './icons/files/all'
import icon_doc from './icons/files/doc'
import icon_jpeg from './icons/files/jpeg'
import icon_jpg from './icons/files/jpg'
import icon_mp3 from './icons/files/mp3'
import icon_mp4 from './icons/files/mp4'
import icon_pdf from './icons/files/pdf'
import icon_ppt from './icons/files/ppt'
import icon_pptx from './icons/files/pptx'
import icon_rtf from './icons/files/rtf'
import icon_tif from './icons/files/tif'
import icon_tiff from './icons/files/tiff'
import icon_txt from './icons/files/txt'
import icon_wav from './icons/files/wav'
import icon_xls from './icons/files/xls'
import icon_xlsx from './icons/files/xlsx'
import icon_zip from './icons/files/zip'
import icon_help from './icons/button/help'
import icon_logo_gosuslugi from './icons/other/logo_gosuslugi'
import icon_clock from './icons/other/clock'
import icon_search from './icons/button/search'
import icon_complaint from './icons/button/complaint'
import './icon.sass'

const icons = {
  icon_1, icon_2, icon_3,icon_4,icon_6, icon_5,icon_7,icon_8,icon_9,icon_10,icon_11,icon_12,icon_13,icon_14,icon_15,icon_16,icon_17,icon_18,icon_19,icon_20,icon_22,icon_23,icon_24,icon_26,
  icon_27,icon_28,icon_29,icon_30,icon_31,icon_31_2,icon_32,icon_33,icon_34,icon_35,icon_36,icon_37,icon_38,icon_39,icon_40,icon_41,icon_42,icon_43,icon_44,icon_49,icon_51,
  icon_52,icon_53,icon_54,icon_55,icon_56,icon_62,icon_64,icon_66,icon_67,//uslugas
  icon_logo_gosuslugi, icon_clock,  //other
  icon_help, icon_search, icon_complaint, //button
  icon_all, icon_doc, icon_jpeg, icon_jpg, icon_mp3, icon_mp4, icon_pdf, icon_ppt, icon_pptx, icon_rtf, icon_tif, icon_tiff, icon_txt, icon_wav, icon_xls, icon_xlsx, icon_zip // files
}

const Icon = ({ fill, type, ...props }) => {
  const icon = icons[`icon_${type.toString()}`] || icons['icon_1']

  {/* eslint-disable */}

  return (
    <span
      className="iconUslugi"
      dangerouslySetInnerHTML={{ __html: icon(fill) }}
      {...props}
    />
  )
}

Icon.propTypes = {
  fill: PropTypes.string
}

Icon.defaultProps = {
  fill: '',
  type: '1'
}

export default Icon


// WEBPACK FOOTER //
// ./components/Icon/index.jsx